var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"support-iframe","src":_vm.supportUrl,"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }